import { useState } from 'react';
import { X } from 'lucide-react';
import { accepteerRuilverzoekApi } from '../lib/api.js';
import { datumNL } from '../lib/datum.js';
import DienstKiezer from './DienstKiezer.jsx';

// De gevraagde collega kiest een van ZIJN eigen komende diensten als tegendienst. Toont
// bovenaan het oorspronkelijke aanbod ter context, daaronder de DienstKiezer.
export default function TegendienstModal({ open, verzoek, onClose, onGekozen }) {
  const [fout, setFout] = useState(null);
  const [bezig, setBezig] = useState(false);

  if (!open || !verzoek) return null;

  const aanbod = verzoek.aangebodenDienst || {};

  const kies = async (tegendienst) => {
    if (bezig) return;
    setFout(null);
    setBezig(true);
    try {
      await accepteerRuilverzoekApi(verzoek.id, tegendienst);
      onGekozen?.();
      onClose();
    } catch (err) {
      setFout(err.message);
      setBezig(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        className="bg-white rounded-2xl border border-slate-200 shadow-xl w-full max-w-lg max-h-[85vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
          <h2 className="font-semibold text-slate-800">Kies je tegendienst</h2>
          <button onClick={onClose} aria-label="Sluiten" className="p-1 rounded hover:bg-slate-100 text-slate-500">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 overflow-y-auto space-y-3">
          {/* Context: het oorspronkelijke aanbod van de indiener */}
          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <div className="text-xs uppercase tracking-wide text-slate-400">{verzoek.indienerNaam} biedt</div>
            <div className="text-sm font-medium text-slate-800 mt-0.5">{datumNL(aanbod.datum)}</div>
            <div className="text-xs text-slate-500">{aanbod.dienstLabel} · {aanbod.gemeenteLabel}</div>
          </div>

          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 pt-1">
            Kies een van je eigen diensten als tegendienst
          </div>

          {bezig ? (
            <p className="text-sm text-slate-500">Bezig met accepteren…</p>
          ) : (
            <DienstKiezer onKies={kies} />
          )}

          {fout && <p className="text-sm text-red-600 pt-1">{fout}</p>}
        </div>
      </div>
    </div>
  );
}
